export function formatVirtualTournamentCountdown(ms: number): string {
  if (ms <= 0) return "Скоро"
  const totalSec = Math.floor(ms / 1000)
  const days = Math.floor(totalSec / 86400)
  const hours = Math.floor((totalSec % 86400) / 3600)
  const minutes = Math.floor((totalSec % 3600) / 60)
  const seconds = totalSec % 60

  if (days > 0) return `${days}д ${hours}ч ${minutes}м`
  if (hours > 0) return `${hours}ч ${minutes}м ${seconds}с`
  if (minutes > 0) return `${minutes}м ${seconds}с`
  return `${seconds}с`
}
